import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { pingBackend } from './services/api';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { EntitlementsProvider } from './hooks/useEntitlements';
import ProtectedRoute from './components/ProtectedRoute';
import AuthPage from './pages/AuthPage';
import HomePage from './pages/HomePage';
import InvoiceGenerator from './components/InvoiceGenerator';
import InvoiceHistoryPage from './pages/InvoiceHistoryPage';
import InvoiceDetailPage from './pages/InvoiceDetailPage';
import ProfilePage from './pages/ProfilePage';
import ClientsPage from './pages/ClientsPage';
import SharedInvoicePage from './pages/SharedInvoicePage';
import SettingsPage from './pages/SettingsPage';
import BillingPage from './pages/BillingPage';
import AdminPage from './pages/AdminPage';
import FreeInvoiceGeneratorPage from './pages/seo/FreeInvoiceGeneratorPage';
import GstInvoiceGeneratorPage from './pages/seo/GstInvoiceGeneratorPage';
import FreelancerInvoiceGeneratorPage from './pages/seo/FreelancerInvoiceGeneratorPage';
import VatInvoiceGeneratorPage from './pages/seo/VatInvoiceGeneratorPage';
import InvoiceGeneratorIndiaPage from './pages/seo/InvoiceGeneratorIndiaPage';
import GstInvoiceTemplatePage from './pages/seo/GstInvoiceTemplatePage';
import FreelancerInvoiceTemplatePage from './pages/seo/FreelancerInvoiceTemplatePage';
import InvoiceTemplateIndiaPage from './pages/seo/InvoiceTemplateIndiaPage';
import ServiceInvoiceTemplatePage from './pages/seo/ServiceInvoiceTemplatePage';
import InternationalInvoiceGeneratorPage from './pages/seo/InternationalInvoiceGeneratorPage';
import CoachInvoiceGeneratorPage from './pages/seo/CoachInvoiceGeneratorPage';
import CoachInvoiceTemplatePage from './pages/seo/CoachInvoiceTemplatePage';
import VatInvoiceTemplatePage from './pages/seo/VatInvoiceTemplatePage';
import InvoiceGeneratorUKPage from './pages/seo/InvoiceGeneratorUKPage';
import InvoiceGeneratorAustraliaPage from './pages/seo/InvoiceGeneratorAustraliaPage';
import SelfEmployedInvoiceTemplatePage from './pages/seo/SelfEmployedInvoiceTemplatePage';
import ContractorInvoiceTemplatePage from './pages/seo/ContractorInvoiceTemplatePage';
import InvoiceGeneratorUSPage from './pages/seo/InvoiceGeneratorUSPage';
import InvoiceGeneratorCanadaPage from './pages/seo/InvoiceGeneratorCanadaPage';
import InvoiceGeneratorUAEPage from './pages/seo/InvoiceGeneratorUAEPage';
import InvoiceGeneratorSingaporePage from './pages/seo/InvoiceGeneratorSingaporePage';
import PhotographerInvoiceTemplatePage from './pages/seo/PhotographerInvoiceTemplatePage';
import GraphicDesignerInvoiceTemplatePage from './pages/seo/GraphicDesignerInvoiceTemplatePage';
import WebDeveloperInvoiceTemplatePage from './pages/seo/WebDeveloperInvoiceTemplatePage';
import ConsultantInvoiceTemplatePage from './pages/seo/ConsultantInvoiceTemplatePage';
import PersonalTrainerInvoiceTemplatePage from './pages/seo/PersonalTrainerInvoiceTemplatePage';
import CopywriterInvoiceTemplatePage from './pages/seo/CopywriterInvoiceTemplatePage';
import TutorInvoiceTemplatePage from './pages/seo/TutorInvoiceTemplatePage';
import VirtualAssistantInvoiceTemplatePage from './pages/seo/VirtualAssistantInvoiceTemplatePage';
import MarketingConsultantInvoiceTemplatePage from './pages/seo/MarketingConsultantInvoiceTemplatePage';
import InteriorDesignerInvoiceTemplatePage from './pages/seo/InteriorDesignerInvoiceTemplatePage';
import PlumberInvoiceTemplatePage from './pages/seo/PlumberInvoiceTemplatePage';
import ElectricianInvoiceTemplatePage from './pages/seo/ElectricianInvoiceTemplatePage';
import MusicianInvoiceTemplatePage from './pages/seo/MusicianInvoiceTemplatePage';
import TherapistInvoiceTemplatePage from './pages/seo/TherapistInvoiceTemplatePage';
import InvoiceGeneratorNewZealandPage from './pages/seo/InvoiceGeneratorNewZealandPage';
import InvoiceGeneratorSouthAfricaPage from './pages/seo/InvoiceGeneratorSouthAfricaPage';
import InvoiceGeneratorIrelandPage from './pages/seo/InvoiceGeneratorIrelandPage';
import InvoiceGeneratorPakistanPage from './pages/seo/InvoiceGeneratorPakistanPage';
import InvoiceGeneratorBangladeshPage from './pages/seo/InvoiceGeneratorBangladeshPage';
import InvoiceGeneratorPhilippinesPage from './pages/seo/InvoiceGeneratorPhilippinesPage';
import InvoiceGeneratorNigeriaPage from './pages/seo/InvoiceGeneratorNigeriaPage';
import InvoiceGeneratorKenyaPage from './pages/seo/InvoiceGeneratorKenyaPage';
import InvoiceGeneratorMalaysiaPage from './pages/seo/InvoiceGeneratorMalaysiaPage';
import InvoiceGeneratorGermanyPage from './pages/seo/InvoiceGeneratorGermanyPage';
import InvoiceGeneratorNetherlandsPage from './pages/seo/InvoiceGeneratorNetherlandsPage';
import InvoiceGeneratorSwedenPage from './pages/seo/InvoiceGeneratorSwedenPage';
import InvoiceGeneratorNorwayPage from './pages/seo/InvoiceGeneratorNorwayPage';
import InvoiceGeneratorSriLankaPage from './pages/seo/InvoiceGeneratorSriLankaPage';
import InvoiceGeneratorIndonesiaPage from './pages/seo/InvoiceGeneratorIndonesiaPage';
import InvoiceGeneratorRwandaPage from './pages/seo/InvoiceGeneratorRwandaPage';
import BlogIndexPage from './pages/blog/BlogIndexPage';
import HowToCreateGstInvoiceIndiaPage from './pages/blog/HowToCreateGstInvoiceIndiaPage';
import FreelanceInvoiceChecklistPage from './pages/blog/FreelanceInvoiceChecklistPage';
import InvoiceInternationalClientsPage from './pages/blog/InvoiceInternationalClientsPage';
import InvoiceVsReceiptPage from './pages/blog/InvoiceVsReceiptPage';
import UkVatInvoiceRequirementsPage from './pages/blog/UkVatInvoiceRequirementsPage';
import HowToCalculateGstPage from './pages/blog/HowToCalculateGstPage';
import LatePaymentEmailPage from './pages/blog/LatePaymentEmailPage';
import GstInvoiceFormatPage from './pages/blog/GstInvoiceFormatPage';
import InvoicePaymentTermsPage from './pages/blog/InvoicePaymentTermsPage';
import InvoiceNumberingPage from './pages/blog/InvoiceNumberingPage';
import DueUponReceiptPage from './pages/blog/DueUponReceiptPage';
import SimplifiedVatInvoicePage from './pages/blog/SimplifiedVatInvoicePage';
import Net15PaymentTermsPage from './pages/blog/Net15PaymentTermsPage';
import UkInvoiceRequirementsPage from './pages/blog/UkInvoiceRequirementsPage';
import AustraliaTaxInvoicePage from './pages/blog/AustraliaTaxInvoicePage';
import SelfEmployedInvoicePage from './pages/blog/SelfEmployedInvoicePage';
import HowToInvoiceAsCoachUkPage from './pages/blog/HowToInvoiceAsCoachUkPage';
import HowToInvoiceFreelancerNigeriaPage from './pages/blog/HowToInvoiceFreelancerNigeriaPage';
import HowToInvoiceClientsKenyaPage from './pages/blog/HowToInvoiceClientsKenyaPage';
import HowToInvoiceFreelancerSouthAfricaPage from './pages/blog/HowToInvoiceFreelancerSouthAfricaPage';
import HowToInvoicePersonalTrainerUkPage from './pages/blog/HowToInvoicePersonalTrainerUkPage';
import HowToInvoicePhotographerUkPage from './pages/blog/HowToInvoicePhotographerUkPage';
import CrispChat from './components/CrispChat';
import { usePageTracking } from './utils/analytics';
import './styles/index.css';

function AppRoutes() {
  usePageTracking();
  const location = useLocation();
  const isAdmin = location.pathname === '/rajlogin';
  return (
    <div className="App min-h-screen bg-white dark:bg-gray-950 transition-colors duration-200">
      {!isAdmin && <CrispChat />}
      <Routes>
        {/* Core app */}
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/create/:invoiceType" element={<InvoiceGenerator />} />
        <Route path="/create" element={<InvoiceGenerator />} />
        <Route path="/history" element={<ProtectedRoute><InvoiceHistoryPage /></ProtectedRoute>} />
        <Route path="/history/:invoiceId" element={<ProtectedRoute><InvoiceDetailPage /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/clients" element={<ProtectedRoute><ClientsPage /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
        <Route path="/billing" element={<ProtectedRoute><BillingPage /></ProtectedRoute>} />
        <Route path="/view/:token" element={<SharedInvoicePage />} />
        <Route path="/rajlogin" element={<AdminPage />} />

        {/* SEO landing pages — Type A (invoice type generators) */}
        <Route path="/free-invoice-generator" element={<FreeInvoiceGeneratorPage />} />
        <Route path="/gst-invoice-generator" element={<GstInvoiceGeneratorPage />} />
        <Route path="/freelancer-invoice-generator" element={<FreelancerInvoiceGeneratorPage />} />
        <Route path="/vat-invoice-generator" element={<VatInvoiceGeneratorPage />} />
        <Route path="/invoice-generator-india" element={<InvoiceGeneratorIndiaPage />} />

        <Route path="/international-invoice-generator" element={<InternationalInvoiceGeneratorPage />} />
        <Route path="/coach-invoice-generator" element={<CoachInvoiceGeneratorPage />} />

        {/* SEO landing pages — Type B (template pages) */}
        <Route path="/gst-invoice-template" element={<GstInvoiceTemplatePage />} />
        <Route path="/freelancer-invoice-template" element={<FreelancerInvoiceTemplatePage />} />
        <Route path="/invoice-template-india" element={<InvoiceTemplateIndiaPage />} />
        <Route path="/service-invoice-template" element={<ServiceInvoiceTemplatePage />} />
        <Route path="/coach-invoice-template" element={<CoachInvoiceTemplatePage />} />
        <Route path="/vat-invoice-template" element={<VatInvoiceTemplatePage />} />
        <Route path="/self-employed-invoice-template" element={<SelfEmployedInvoiceTemplatePage />} />
        <Route path="/contractor-invoice-template" element={<ContractorInvoiceTemplatePage />} />

        {/* SEO landing pages — Type C (country/region pages) */}
        <Route path="/invoice-generator-uk" element={<InvoiceGeneratorUKPage />} />
        <Route path="/invoice-generator-australia" element={<InvoiceGeneratorAustraliaPage />} />
        <Route path="/invoice-generator-us" element={<InvoiceGeneratorUSPage />} />
        <Route path="/invoice-generator-canada" element={<InvoiceGeneratorCanadaPage />} />
        <Route path="/invoice-generator-uae" element={<InvoiceGeneratorUAEPage />} />
        <Route path="/invoice-generator-singapore" element={<InvoiceGeneratorSingaporePage />} />

        {/* SEO landing pages — Type D (profession-specific templates) */}
        <Route path="/photographer-invoice-template" element={<PhotographerInvoiceTemplatePage />} />
        <Route path="/graphic-designer-invoice-template" element={<GraphicDesignerInvoiceTemplatePage />} />
        <Route path="/web-developer-invoice-template" element={<WebDeveloperInvoiceTemplatePage />} />
        <Route path="/consultant-invoice-template" element={<ConsultantInvoiceTemplatePage />} />
        <Route path="/personal-trainer-invoice-template" element={<PersonalTrainerInvoiceTemplatePage />} />
        <Route path="/copywriter-invoice-template" element={<CopywriterInvoiceTemplatePage />} />
        <Route path="/tutor-invoice-template" element={<TutorInvoiceTemplatePage />} />
        <Route path="/virtual-assistant-invoice-template" element={<VirtualAssistantInvoiceTemplatePage />} />
        <Route path="/marketing-consultant-invoice-template" element={<MarketingConsultantInvoiceTemplatePage />} />
        <Route path="/interior-designer-invoice-template" element={<InteriorDesignerInvoiceTemplatePage />} />
        <Route path="/plumber-invoice-template" element={<PlumberInvoiceTemplatePage />} />
        <Route path="/electrician-invoice-template" element={<ElectricianInvoiceTemplatePage />} />
        <Route path="/musician-invoice-template" element={<MusicianInvoiceTemplatePage />} />
        <Route path="/therapist-invoice-template" element={<TherapistInvoiceTemplatePage />} />

        {/* SEO landing pages — Type C continued (new country pages) */}
        <Route path="/invoice-generator-new-zealand" element={<InvoiceGeneratorNewZealandPage />} />
        <Route path="/invoice-generator-south-africa" element={<InvoiceGeneratorSouthAfricaPage />} />
        <Route path="/invoice-generator-ireland" element={<InvoiceGeneratorIrelandPage />} />
        <Route path="/invoice-generator-pakistan" element={<InvoiceGeneratorPakistanPage />} />
        <Route path="/invoice-generator-bangladesh" element={<InvoiceGeneratorBangladeshPage />} />
        <Route path="/invoice-generator-philippines" element={<InvoiceGeneratorPhilippinesPage />} />
        <Route path="/invoice-generator-nigeria" element={<InvoiceGeneratorNigeriaPage />} />
        <Route path="/invoice-generator-kenya" element={<InvoiceGeneratorKenyaPage />} />
        <Route path="/invoice-generator-malaysia" element={<InvoiceGeneratorMalaysiaPage />} />
        <Route path="/invoice-generator-germany" element={<InvoiceGeneratorGermanyPage />} />
        <Route path="/invoice-generator-netherlands" element={<InvoiceGeneratorNetherlandsPage />} />
        <Route path="/invoice-generator-sweden" element={<InvoiceGeneratorSwedenPage />} />
        <Route path="/invoice-generator-norway" element={<InvoiceGeneratorNorwayPage />} />
        <Route path="/invoice-generator-sri-lanka" element={<InvoiceGeneratorSriLankaPage />} />
        <Route path="/invoice-generator-indonesia" element={<InvoiceGeneratorIndonesiaPage />} />
        <Route path="/invoice-generator-rwanda" element={<InvoiceGeneratorRwandaPage />} />

        {/* Blog — index and articles */}
        <Route path="/blog" element={<BlogIndexPage />} />
        <Route path="/blog/how-to-create-gst-invoice-india" element={<HowToCreateGstInvoiceIndiaPage />} />
        <Route path="/blog/what-to-include-freelance-invoice" element={<FreelanceInvoiceChecklistPage />} />
        <Route path="/blog/how-to-invoice-international-clients" element={<InvoiceInternationalClientsPage />} />
        <Route path="/blog/invoice-vs-receipt" element={<InvoiceVsReceiptPage />} />
        <Route path="/blog/vat-invoice-requirements-uk" element={<UkVatInvoiceRequirementsPage />} />
        <Route path="/blog/how-to-calculate-gst-invoice" element={<HowToCalculateGstPage />} />
        <Route path="/blog/late-payment-follow-up-email" element={<LatePaymentEmailPage />} />
        <Route path="/blog/gst-invoice-format-india" element={<GstInvoiceFormatPage />} />
        <Route path="/blog/invoice-payment-terms" element={<InvoicePaymentTermsPage />} />
        <Route path="/blog/how-to-number-invoices" element={<InvoiceNumberingPage />} />
        <Route path="/blog/what-does-due-upon-receipt-mean" element={<DueUponReceiptPage />} />
        <Route path="/blog/simplified-vat-invoice" element={<SimplifiedVatInvoicePage />} />
        <Route path="/blog/net-15-payment-terms" element={<Net15PaymentTermsPage />} />
        <Route path="/blog/uk-invoice-requirements" element={<UkInvoiceRequirementsPage />} />
        <Route path="/blog/australia-tax-invoice-guide" element={<AustraliaTaxInvoicePage />} />
        <Route path="/blog/self-employed-invoice-guide" element={<SelfEmployedInvoicePage />} />
        <Route path="/blog/how-to-invoice-as-a-coach-uk" element={<HowToInvoiceAsCoachUkPage />} />
        <Route path="/blog/how-to-invoice-as-freelancer-nigeria" element={<HowToInvoiceFreelancerNigeriaPage />} />
        <Route path="/blog/how-to-invoice-clients-kenya" element={<HowToInvoiceClientsKenyaPage />} />
        <Route path="/blog/how-to-invoice-as-freelancer-south-africa" element={<HowToInvoiceFreelancerSouthAfricaPage />} />
        <Route path="/blog/how-to-invoice-as-personal-trainer-uk" element={<HowToInvoicePersonalTrainerUkPage />} />
        <Route path="/blog/how-to-invoice-as-photographer-uk" element={<HowToInvoicePhotographerUkPage />} />
      </Routes>
    </div>
  );
}

function App() {
  // Pre-warm the Render free-tier backend on first load so it's ready by the
  // time the user reaches any auth or data endpoint (cold start = ~30-60s).
  useEffect(() => { pingBackend(); }, []);

  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <EntitlementsProvider>
            <Router>
              <AppRoutes />
            </Router>
          </EntitlementsProvider>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
